// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;
}

.gl-container #scene {
  top: 0px !important;
  left: 0px !important;
}

pre {
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  white-space: pre-wrap;
  box-sizing: border-box;
  border: 3px solid #e0e0e0;
}

button {
  overflow-wrap: initial;
  word-break: initial;
}

.TabPanel {
  display: flex;
  height: 100%;
}

.MuiToolbar-root .MuiBox-root {
  border-bottom: none;
}

.MuiTabs-root .MuiTabs-indicator {
  background-color: orange;
}

.SystemInfo {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  flex-grow: 1;
}

.SystemInfoItem {
  display: flex; /* Grid for individual items */
  flex-direction: row;
  flex-grow: 1;
}

.SystemInfoItem > div:first-child {
  display: flex;
  justify-self: end; /* Align the first column content to the right */
  width: 10rem;
}

.SystemInfoItem > div:last-child {
  display: flex;
  flex-grow: 1;
  justify-self: end; /* Align the first column content to the right */
}

.DocBox {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 2048px;
  margin: 0 auto;
}

.Controls {
  display: flex;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  overflow-y: auto;
  padding: 10px;
  flex-direction: column;
  margin-left: 10px;
  box-sizing: border-box;
  overflow-x: visible;
  min-width: 10rem;
  flex-grow: 1;
}

.MessageContent div > p:first-child {
  margin-top: 0;
}

.MenuCard.MuiCard-root {
  display: flex;
  flex-direction: column;
  min-width: 10rem;
  flex-grow: 1;
  background-color: #1a2536; /* Midnight Blue */
  color: #d3cdbf; /* Warm Gray */
  border-radius: 0;
}

.MenuCard.MuiCard-root button {
  min-height: 64px;
}
/* Prevent toolbar from shrinking vertically when media < 600px */
.MuiToolbar-root {
  min-height: 72px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.ChatBox {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  background-color: #d3cdbf;
}

.user-message.MuiCard-root {
  background-color: #dcf8c6;
  border: 1px solid #b2e0a7;
  color: #333333;
  margin-bottom: 0.75rem;
  margin-left: 1rem;
  border-radius: 0.25rem;
  min-width: 80%;
  max-width: 80%;
  justify-self: right;
  display: flex;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  flex-direction: column;
  align-items: self-end;
  align-self: end;
  flex-grow: 0;
}

.Docs.MuiCard-root,
.assistant-message.MuiCard-root {
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  color: #333333;
  margin-bottom: 0.75rem;
  margin-right: 1rem;
  min-width: 70%;
  border-radius: 0.25rem;
  justify-self: left;
  display: flex;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  flex-direction: column;
  flex-grow: 0;
  padding: 16px 0;
  font-size: 0.9rem;
}

.Docs.MuiCard-root {
  display: flex;
  flex-grow: 1;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.Docs .MuiCardContent-root,
.assistant-message .MuiCardContent-root {
  padding: 0 16px !important;
  font-size: 0.9rem;
}

.Docs span,
.assistant-message span {
  font-size: 0.9rem;
}

.user-message .MuiCardContent-root:last-child,
.assistant-message .MuiCardContent-root:last-child,
.Docs .MuiCardContent-root:last-child {
  padding: 16px;
}

.users > div {
  padding: 0.25rem;
}

.user-active {
  font-weight: bold;
}

.metadata {
  border: 1px solid #e0e0e0;
  font-size: 0.75rem;
  padding: 0.125rem;
}

/* Reduce general whitespace in markdown content */
* p.MuiTypography-root {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Reduce space between headings and content */
/* * h1.MuiTypography-root,
* h2.MuiTypography-root,
* h3.MuiTypography-root,
* h4.MuiTypography-root,
* h5.MuiTypography-root,
* h6.MuiTypography-root {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
} */

/* Reduce space in lists */
* ul.MuiTypography-root,
* ol.MuiTypography-root {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

* li.MuiTypography-root {
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

* .MuiTypography-root li {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  font-size: 0.9rem;
}

/* Reduce space around code blocks */
* .MuiTypography-root pre {
  border: 1px solid #f5f5f5;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.PromptStats .MuiTableCell-root {
  font-size: 0.8rem;
}

#SystemPromptInput {
  font-size: 0.9rem;
  line-height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/BackstoryApp.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,8BAA8B;EAC7C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,gDAAgD;EACnE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB,EAAE,gDAAgD;AACrE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB,EAAE,kBAAkB;EAC7C,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA,iEAAiE;AACjE;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;;;;;;;;;GASG;;AAEH,0BAA0B;AAC1B;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["div {\n  box-sizing: border-box;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.gl-container #scene {\n  top: 0px !important;\n  left: 0px !important;\n}\n\npre {\n  max-width: 100%;\n  max-height: 100%;\n  overflow: auto;\n  white-space: pre-wrap;\n  box-sizing: border-box;\n  border: 3px solid #e0e0e0;\n}\n\nbutton {\n  overflow-wrap: initial;\n  word-break: initial;\n}\n\n.TabPanel {\n  display: flex;\n  height: 100%;\n}\n\n.MuiToolbar-root .MuiBox-root {\n  border-bottom: none;\n}\n\n.MuiTabs-root .MuiTabs-indicator {\n  background-color: orange;\n}\n\n.SystemInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 5px;\n  flex-grow: 1;\n}\n\n.SystemInfoItem {\n  display: flex; /* Grid for individual items */\n  flex-direction: row;\n  flex-grow: 1;\n}\n\n.SystemInfoItem > div:first-child {\n  display: flex;\n  justify-self: end; /* Align the first column content to the right */\n  width: 10rem;\n}\n\n.SystemInfoItem > div:last-child {\n  display: flex;\n  flex-grow: 1;\n  justify-self: end; /* Align the first column content to the right */\n}\n\n.DocBox {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  max-width: 2048px;\n  margin: 0 auto;\n}\n\n.Controls {\n  display: flex;\n  background-color: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  overflow-y: auto;\n  padding: 10px;\n  flex-direction: column;\n  margin-left: 10px;\n  box-sizing: border-box;\n  overflow-x: visible;\n  min-width: 10rem;\n  flex-grow: 1;\n}\n\n.MessageContent div > p:first-child {\n  margin-top: 0;\n}\n\n.MenuCard.MuiCard-root {\n  display: flex;\n  flex-direction: column;\n  min-width: 10rem;\n  flex-grow: 1;\n  background-color: #1a2536; /* Midnight Blue */\n  color: #d3cdbf; /* Warm Gray */\n  border-radius: 0;\n}\n\n.MenuCard.MuiCard-root button {\n  min-height: 64px;\n}\n/* Prevent toolbar from shrinking vertically when media < 600px */\n.MuiToolbar-root {\n  min-height: 72px !important;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.ChatBox {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  max-width: 1024px;\n  width: 100%;\n  margin: 0 auto;\n  background-color: #d3cdbf;\n}\n\n.user-message.MuiCard-root {\n  background-color: #dcf8c6;\n  border: 1px solid #b2e0a7;\n  color: #333333;\n  margin-bottom: 0.75rem;\n  margin-left: 1rem;\n  border-radius: 0.25rem;\n  min-width: 80%;\n  max-width: 80%;\n  justify-self: right;\n  display: flex;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  flex-direction: column;\n  align-items: self-end;\n  align-self: end;\n  flex-grow: 0;\n}\n\n.Docs.MuiCard-root,\n.assistant-message.MuiCard-root {\n  border: 1px solid #e0e0e0;\n  background-color: #ffffff;\n  color: #333333;\n  margin-bottom: 0.75rem;\n  margin-right: 1rem;\n  min-width: 70%;\n  border-radius: 0.25rem;\n  justify-self: left;\n  display: flex;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  flex-direction: column;\n  flex-grow: 0;\n  padding: 16px 0;\n  font-size: 0.9rem;\n}\n\n.Docs.MuiCard-root {\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.Docs .MuiCardContent-root,\n.assistant-message .MuiCardContent-root {\n  padding: 0 16px !important;\n  font-size: 0.9rem;\n}\n\n.Docs span,\n.assistant-message span {\n  font-size: 0.9rem;\n}\n\n.user-message .MuiCardContent-root:last-child,\n.assistant-message .MuiCardContent-root:last-child,\n.Docs .MuiCardContent-root:last-child {\n  padding: 16px;\n}\n\n.users > div {\n  padding: 0.25rem;\n}\n\n.user-active {\n  font-weight: bold;\n}\n\n.metadata {\n  border: 1px solid #e0e0e0;\n  font-size: 0.75rem;\n  padding: 0.125rem;\n}\n\n/* Reduce general whitespace in markdown content */\n* p.MuiTypography-root {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n/* Reduce space between headings and content */\n/* * h1.MuiTypography-root,\n* h2.MuiTypography-root,\n* h3.MuiTypography-root,\n* h4.MuiTypography-root,\n* h5.MuiTypography-root,\n* h6.MuiTypography-root {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n} */\n\n/* Reduce space in lists */\n* ul.MuiTypography-root,\n* ol.MuiTypography-root {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n* li.MuiTypography-root {\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n}\n\n* .MuiTypography-root li {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 0;\n  font-size: 0.9rem;\n}\n\n/* Reduce space around code blocks */\n* .MuiTypography-root pre {\n  border: 1px solid #f5f5f5;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 0.9rem;\n}\n\n.PromptStats .MuiTableCell-root {\n  font-size: 0.8rem;\n}\n\n#SystemPromptInput {\n  font-size: 0.9rem;\n  line-height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
